import { Routes } from '@angular/router';
import { onboardingGuard } from './core/guards/onboarding.guard';
import { treatmentGuard } from './core/guards/treatment.guard';

export const routes: Routes = [
  {
    path: 'onboarding',
    loadComponent: () => import('./features/onboarding/onboarding.component').then(m => m.OnboardingComponent)
  },
  {
    path: 'error',
    loadComponent: () => import('./features/error/error.component').then(m => m.ErrorComponent)
  },
  {
    path: '',
    canActivate: [treatmentGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./layout/layout.component').then(m => m.LayoutComponent),
        canActivate: [onboardingGuard],
        children: [
          {
            path: 'dashboard',
            loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
          },
          {
            path: 'review',
            loadComponent: () => import('./features/rate/rate.component').then(m => m.RateComponent)
          },
          {
            path: 'fun',
            loadComponent: () => import('./features/fun/fun.component').then(m => m.FunComponent)
          },
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full'
          }
        ]
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/error?type=404'
  }
];
